import { db } from '@flow/config/firebase';
import { collection, getDoc, doc, setDoc } from 'firebase/firestore';

export async function fetchFavourites(
  uid: string | null
): Promise<Favourite[]> {
  if (uid) {
    const docRef = doc(db, 'Users', uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists && docSnap.data().favourites) {
      return docSnap.data().favourites;
    }
  }
  return [];
}

export async function setUserFavourites(
  uid: string | null,
  favourites: Favourite[]
) {
  if (uid) {
    const usercollection = collection(db, 'Users');
    await setDoc(doc(usercollection, uid), {
      favourites: favourites,
    });
  }
}



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/api/favourites.ts